<template>
  <div class="quota-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        ref="crud"
        :option="tableConfig"
        :data="tableData"
        v-model="form"
        :page.sync="page"
        :search.sync="searchForm"
        :table-loading="loading"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-save="rowSave"
        @row-update="rowUpdate"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="saveData(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>
        <template slot="fileForm" slot-scope="scope">
          <div class="upload-container">
            <WordUpload
              @showFileName="showFileName"
              baFileMenuId="1552135196465123330"
              :id="id"
              :plain="true"
              :tip="true"
              :readonly="file.length == 1"
            />
            <!--readonly  只能传X个 -->
            <div class="">
              <template v-for="(item, index) in file">
                <div class="file_wrapper" :key="index">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="
                      isWord(item.fileUrl)
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          item.fileUrl
                        : item.fileUrl
                    "
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            v-if="permission.residentwork_add"
            @click="handleAdd()"
          >
            新增驻点总结</el-button
          >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="permission.residentwork_add"
            :disabled="disabled"
            @click.stop="handleEdit()"
            >编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.residentwork_add"
            :disabled="disabled"
            @click.stop="handleDelete()"
            >删除
          </el-button>

          <!-- <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button> -->
        </template>

        <template slot="file" slot-scope="{ row }">
          <div class="project-name">
            <template v-for="(item, index) in row.file">
              <div class="file_wrapper" :key="index">
                <a
                  class="file_button"
                  target="_blank"
                  :href="
                    isWord(item.fileUrl)
                      ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                        item.fileUrl
                      : item.fileUrl
                  "
                  type="text"
                  size="small"
                >
                  {{ item.fileName }}
                </a>
              </div>
            </template>
          </div>
        </template>
      </avue-crud>
    </div>

    <!-- <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="60%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <div class="drawer_screen_wrapper">
        <div class="screen_header">
          <div class="screen_header_name">
            <a-icon type="filter" />
            高级筛选
          </div>
          <div class="screen_header_remarks" @click="drawer = false">
            <i class="el-icon-video-play"></i>
            收起
          </div>
        </div>
        <div class="screen_content">
          <avue-form
            :option="filterConfig"
            ref="formScreen"
            v-model="searchForm"
            @submit="filterSearch"
            @reset-change="searchResetScreen"
          >
            <template slot="factoringCredit">
              <div class="form_slot">
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="开始数值"
                  style="width: 100%"
                />
                &nbsp;~&nbsp;
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="结束数值"
                  style="width: 100%"
                />
              </div>
            </template>
          </avue-form>
        </div>
      </div>
    </el-drawer> -->

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>

<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import WordUpload from "@/components/wordUpload/wordUpload";
import { downLoadTemplate, downLoadTemplateGet } from "@/router/downLoadTem";
import { residentworkConfig } from "./config";
import * as api from "@/api/zd/all";
import * as dictionaries from "@/api/zd/dictionaries";
import { queryInventedId } from "@/api/factoring/factoringCustomer";
import { mapGetters } from "vuex";
export default {
  name: "residentwork",

  data() {
    return {
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      form: {},
      searchForm: {},
      file: [],
      drawer: false,
      id: "",
      tableConfig: residentworkConfig(this.getMoney),
      sortOption: "",
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      loading: false,
      disabled: true,
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
    WordUpload,
    downLoadTemplate,
  },

  watch: {
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return item.createUser != this.userInfo.user_id;
        });

        this.disabled = list.length > 0 || data.length == 0;
      },
      deep: true,
    },
  },
  mounted() {
    this.sortOption = this.tableConfig.column;
    // this.queryTableData();
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  methods: {
    //新增  获取 id
    newId() {
      let self = this;
      queryInventedId().then((res) => {
        if (res["data"]["code"] == 200) {
          self.id = res["data"]["data"];
        }
      });
    },

    //获取选择的数据，进行编辑和删除
    selectionChange(list) {
      this.selectionList = list;
    },

    //搜索框保存按钮
    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    //搜索
    searchChange(params, done) {
      
      this.searchForm = params;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },
    //清空
    searchReset() {
      if (this.cloudStatus) {
        this.cloudStatus = false;
        return;
      }
      this.searchForm = {};
      this.checkUserList = [];
      this.queryTableData();
    },

    //获取分页数据
    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
      };
      let res = await api.getResidentworkList(params);
      if (res.data.code == 200) {
        let data = res.data.data.records;
        data.map((item, index) => {
          this.findFileByOtherId(
            item.id,
            "1552135196465123330",
            "file",
            true,
            index
          );
        });
        this.tableData = data;
        this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },

    //新增
    handleAdd() {
      this.newId();
      Object.assign(this.form, {});
      this.file = [];
      this.$refs.crud.rowAdd();
    },
    //新增
    rowSave(row, done, loading) {
      this.submit(row, done, loading);
    },
    //修改
    rowUpdate(row, index, done, loading) {
      this.submit(row, done, loading);
    },
    // 新增修改 接口
    submit(row, done, loading) {
      let data = {
        // number: row.number,
        name: row.name,
        id: row.id || this.id,
      };
      api.submitResidentwork(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          
          loading();
        }
      );
    },
    showFileName(data, index, raw) {
      this.file = data;
      this.form.file = data;
      this.$refs.crud.clearValidate();
    },
    //编辑接口
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];

        this.id = data.id;
        this.findFileByOtherId(data.id, "1552135196465123330", "file", false);
        this.$refs.crud.rowEdit(data);
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    findFileByOtherId(id, baFileMenuId, name, isList, index) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => {
          if (isList) {
            // this.tableData[index].file = res.data.data;
            this.$set(
              this.tableData[index],
              "file",

              res.data.data
            );
          } else {
            this[name] = res.data.data;
          }

          // this.form[name + "Id"] = res.data.data;
        })
        .catch((res) => {});
    },
    //下载附件
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this[name].splice(index, 1);
          this.form[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    //删除接口
    handleDelete() {
      let self = this;
      // let list = this.selectionList.filter((item) => {
      //   return item.createUser != this.userInfo.user_id;
      // });
      // if (list.length > 0) {
      //   this.$message.error("只能删除自己创建的数据");
      //   return
      // }
      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = this.selectionList.map((item) => {
            return item.id;
          });
          let res = await api.removeResidentwork({ ids: ids.join(",") });
          if (res.data.code == 200) {
            self.$message({
              type: "success",
              message: "删除成功",
            });
            self.queryTableData();
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
.quota-list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
/deep/ .avue-group--card {
  padding: 0 !important;
}
/deep/ .avue-form__menu {
  width: auto !important;
}
/deep/ .avue-form__row {
  padding-left: 0 !important;
}
</style>

